import { offeringTypeLabels } from '../../../../../../../types/domain/offering/constants';
import { sellSideParticipationSupportedOfferingTypes } from '../../../../../../../types/domain/participation-sets/constants';
import { ParticipationSetsGridColDef } from '../../types';

export type Value = string | null | undefined;

export const offeringTypeColDef: ParticipationSetsGridColDef<Value> = {
  field: 'offering.typeDisplayName',
  headerName: 'Offering Type',
  filter: 'agSetColumnFilter',
  floatingFilter: true,
  width: 132,
  // Ideally we come up with a pattern to fetch the status labels from the server and use them here
  filterParams: {
    values: sellSideParticipationSupportedOfferingTypes,
    valueFormatter: ({ value }) => offeringTypeLabels[value] || value,
  },
  server: {
    filterFieldPath: 'offering.type',
    sortFieldPath: 'offering.type.displayName',
  },
};
